import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../components/home.vue'
import video from '../components/video.vue'
import booklet from '../components/booklet.vue'
import cover from '../components/cover.vue'
import lyrics from '../components/lyrics.vue'
import credits from '../components/credits.vue'
import promo from '../components/promo.vue'
import press from '../components/press.vue'
import menu_page from '../components/menu_page.vue'


Vue.use(VueRouter)


const routes = [
  { path: '/item/:id', component: home, props: { footer: true, header: true ,  pageclass: 'homepage' } },
  { path: '/item/:id/home', component: home, props: { footer: true, header: true , pageclass: 'homepage' } },
  { path: '/item/:id/video', component: video, props: { footer: true, header: true, pageclass: 'video' } },
  { path: '/item/:id/booklet', component: booklet, props: { footer: true, header: true } },
  { path: '/item/:id/cover', component: cover, props: { footer: true, header: true } },
  { path: '/item/:id/lyrics', component: lyrics, props: { footer: true, header: true } },
  { path: '/item/:id/credits', component: credits, props: { footer: true, header: true , pageclass: 'credits'} },
  { path: '/item/:id/promo', component: promo, props: { footer: true, header: true } },
  { path: '/item/:id/press', component: press, props: { footer: true, header: true } },
  { path: '/item/:id/menu/:mid', component: menu_page, props: { footer: true, header: true } },
//  { path: '/article/:id', component: articlePAge, props: { footer: true, header: true, footerArticles: true } },

]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
})
 
export default router
